//Fruits
import MIX_FRUITS_IMAGE from "../assets/Images/Products/Fruits/Mix-Fruits.jpg";
import APPlE_IMAGE from "../assets/Images/Products/Fruits/apples-Fruits.jpg";
import BANANA_IMAGE from "../assets/Images/Products/Fruits/banana-Fruits.jpg";
import BREAKFAST_IMAGE from "../assets/Images/Products/Fruits/breakfast-Fruits.jpg";
import CHERRIES_IMAGE from "../assets/Images/Products/Fruits/cherries-Fruits.jpg";
import ORANGE_IMAGE from "../assets/Images/Products/Fruits/oranges-Fruits.jpg";
import PINEAPPLE_IMAGE from "../assets/Images/Products/Fruits/pineapple-Fruits.jpg";
import POMEGRANATE_IMAGE from "../assets/Images/Products/Fruits/pomegranate-Fruits.jpg";
import STRAWBERRY_IMAGE from "../assets/Images/Products/Fruits/strawberries-Fruits.jpg";

//Vegetables
import MIX_VEGETABLES_IMAGE from "../assets/Images/Products/Vegetables/mix-vegetable.jpg";
import ONION_IMAGE from "../assets/Images/Products/Vegetables/onion-Vegetables.jpg";
import CUCUMBER_IMAGE from "../assets/Images/Products/Vegetables/cucumber-Vegetables.jpg";
import DRUMSTICK_IMAGE from "../assets/Images/Products/Vegetables/drumstick-Vegetables.jpg";
import FLOWER_IMAGE from "../assets/Images/Products/Vegetables/flower-Vegetables.jpg";
import POTATOES_IMAGE from "../assets/Images/Products/Vegetables/potatoes-Vegetables.jpg";
import LEMONS_IMAGE from "../assets/Images/Products/Vegetables/lemons-Vegetables.jpg";
import GREEN_CHILLI_IMAGE from "../assets/Images/Products/Vegetables/GreenChilli-Vegetables.jpg";
import RED_CHILLI_IMAGE from "../assets/Images/Products/Vegetables/red-chili-Vegetables.jpg";
import GREEN_PEAS_IMAGE from "../assets/Images/Products/Vegetables/Green-Peas-Vegetables.jpg";
import TOMATOES_IMAGE from "../assets/Images/Products/Vegetables/tomatoes-Vegetables.jpg";
import CABBAGE_IMAGE from "../assets/Images/Products/Vegetables/cabbage-Vegetables.jpg";
import GARLIC_IMAGE from "../assets/Images/Products/Vegetables/garlic-Vegetables.jpg";

//Spices
import MIX_SPICES_IMAGE from "../assets/Images/Products/Spices/spices-cover.jpg";
import ASAFOETIDA_IMAGE from "../assets/Images/Products/Spices/asafoetida-Spices.jpg";
import BADIYA_IMAGE from "../assets/Images/Products/Spices/badiya-Spices.jpg";
import CARADAMOM_IMAGE from "../assets/Images/Products/Spices/cardamom-Spices.jpg";
import CHILLIPOWDER_IMAGE from "../assets/Images/Products/Spices/chilliPowder-Spices.jpg";
import CINNAMON_IMAGE from "../assets/Images/Products/Spices/cinnamon-Spices.jpg";
import CLOVE_IMAGE from "../assets/Images/Products/Spices/clove-Spices.jpg";
import CORIANDER_IMAGE from "../assets/Images/Products/Spices/coriander-Spices.jpg";
import CUMIN_IMAGE from "../assets/Images/Products/Spices/cumin-Spices.jpg";
import FENNEL_IMAGE from "../assets/Images/Products/Spices/fennel-Spices.jpg";
import JAGGERY_IMAGE from "../assets/Images/Products/Spices/jaggerySpices.jpeg";
import MINT_IMAGE from "../assets/Images/Products/Spices/mint-Spices.jpg";
import SPICES_IMAGE from "../assets/Images/Products/Spices/spices-Spices.jpg";
import TURMARIC_IMAGE from "../assets/Images/Products/Spices/turmaric-Spices.jpg";

//Dry Fruits
import MIX_DRY_FRUITS_IMAGE from "../assets/Images/Products/DryFruits/mixDryFruits.jpg";
import ALMONDS_IMAGE from "../assets/Images/Products/DryFruits/almond-DryFruits.jpg";
import CASHEW_IMAGE from "../assets/Images/Products/DryFruits/cashew-DryFruits.jpg";
import MIXDRY_IMAGE from "../assets/Images/Products/DryFruits/mixDry-Fruits.jpg";
import RAISINS_IMAGE from "../assets/Images/Products/DryFruits/raisins-DryFruits.jpg";
import WALNUTS_IMAGE from "../assets/Images/Products/DryFruits/walnuts-DryFruits.jpg";
import FIGS_IMAGE from "../assets/Images/Products/DryFruits/figs-DryFruits.jpg";
import GROUND_NUTS_IMAGE from "../assets/Images/Products/DryFruits/groundNuts.jpg";
import PISTACHIO_IMAGE from "../assets/Images/Products/DryFruits/pistachio-Fruits.jpg";

//Grains
import MIX_GRAINS_IMAGE from "../assets/Images/Products/Grains/grains.jpg";
import BASMATIRICE_IMAGE from "../assets/Images/Products/Grains/basmatiRice-Grains.jpg";
import BLACK_SESAME_IMAGE from "../assets/Images/Products/Grains/black-sesame-Grains.jpg";
import CEREALS_IMAGE from "../assets/Images/Products/Grains/cereals-Grains.jpg";
import NON_BASMATI_RICE_IMAGE from "../assets/Images/Products/Grains/non-basmatiRice-Grains.jpg";
import MILLET_IMAGE from "../assets/Images/Products/Grains/Millet-Grains.jpg";
import SEED_IMAGE from "../assets/Images/Products/Grains/seed-Grains.jpg";
import SORGHUM_IMAGE from "../assets/Images/Products/Grains/sorghum-Grains.jpg";
import WHEAT_IMAGE from "../assets/Images/Products/Grains/wheat-Grains.jpg";
import WHITE_SESAME_IMAGE from "../assets/Images/Products/Grains/white-sesame-Grains.jpg";

//Pulses
import MIX_PULSES_IMAGE from "../assets/Images/Products/Pulses/mix-pulses.jpg";
import CHICKPEA_IMAGE from "../assets/Images/Products/Pulses/chickpea-Pulses.jpg";
import KIDNEY_BEANS_IMAGE from "../assets/Images/Products/Pulses/kidney-beans-Pulses.jpg";
import LENTILS_IMAGE from "../assets/Images/Products/Pulses/lentils-Pulses.jpg";
import MUNG_BEANS_IMAGE from "../assets/Images/Products/Pulses/mung-beans-Pulses.jpg";
import PEAS_GREEN_SPLIT_IMAGE from "../assets/Images/Products/Pulses/peas-green-split-Pulses.jpg";
import PIGEON_PEAS_IMAGE from "../assets/Images/Products/Pulses/pigeon-peas-Pulses.jpg";
import SOYA_BEANS_IMAGE from "../assets/Images/Products/Pulses/soya-beans-Pulses.jpg";
import URAD_IMAGE from "../assets/Images/Products/Pulses/urad-Pulses.jpg";
import YELLOW_SPLIT_IMAGE from "../assets/Images/Products/Pulses/yellow-split-Pulses.jpg";

//Flour
import MIX_FLOUR_IMAGE from "../assets/Images/Products/Flour/flour-Front.jpg";
import GRAM_FLOUR_IMAGE from "../assets/Images/Products/Flour/gram-Flour.jpg";
import MAIDA_FLOUR_IMAGE from "../assets/Images/Products/Flour/maida-Flour.jpg";
import MILLET_FLOUR_IMAGE from "../assets/Images/Products/Flour/millet-Flour.jpg";
import RICE_FLOUR_IMAGE from "../assets/Images/Products/Flour/rice-Flour.jpg";
import SORGHUM_FLOUR_IMAGE from "../assets/Images/Products/Flour/sorghum-Flour.jpg";
import URAD_FLOUR_IMAGE from "../assets/Images/Products/Flour/urad-flour.jpg";
import WHEAT_FLOUR_IMAGE from "../assets/Images/Products/Flour/wheat-Flour.jpg";

// Metal Scab
import MIX_METAL_IMAGE from "../assets/Images/Products/MetalScabs/mix-metal.webp";
import ALUMINUM_IMAGE from "../assets/Images/Products/MetalScabs/Aluminium-UBC-Scrap.jpg";
import ALUMINUM_IGNOTS_IMAGE from "../assets/Images/Products/MetalScabs/aluminum-igots.jpeg";
import ALUMINUM_6063_IMAGE from "../assets/Images/Products/MetalScabs/aluminum-6063-scrap.jpeg";
import ALUMINUM_WIRE_IMAGE from "../assets/Images/Products/MetalScabs/aluminum-wire-scrap.jpeg";
import COPPER_IMAGE from "../assets/Images/Products/MetalScabs/copper-scrap.jpg";
import IRON_IMAGE from "../assets/Images/Products/MetalScabs/ironStole.jpg";

//Other Product
import OTHER_IMAGE from "../assets/Images/OtherProduct.jpg";

//Raw Material
import COTTON_IMAGE from "../assets/Images/Products/RawMaterials/cotton-branch.jpg"
import FOX_NUTS_IMAGE from "../assets/Images/Products/RawMaterials/fox-nuts.jpg"

export const products = [
    {
        categoryId: "FRS01",
        categoryName: "Fruits",
        categoryImage: MIX_FRUITS_IMAGE,
        subCategory: [
            {
                subCatProductId: "08081000",
                subCatProductName: "Apple",
                subCatProductImage: APPlE_IMAGE,
            },
            {
                subCatProductId: "08039010",
                subCatProductName: "Banana",
                subCatProductImage: BANANA_IMAGE,
            },
            {
                subCatProductId: "08105000",
                subCatProductName: "KiWi",
                subCatProductImage: BREAKFAST_IMAGE,
            },
            {
                subCatProductId: "08102100",
                subCatProductName: "Cherries",
                subCatProductImage: CHERRIES_IMAGE,
            },
            {
                subCatProductId: "20083010",
                subCatProductName: "Orange",
                subCatProductImage: ORANGE_IMAGE,
            },
            {
                subCatProductId: "20082000",
                subCatProductName: "Pineapple",
                subCatProductImage: PINEAPPLE_IMAGE,
            },
            {
                subCatProductId: "08109010",
                subCatProductName: "Pomegranate",
                subCatProductImage: POMEGRANATE_IMAGE,
            },
            {
                subCatProductId: "08101000",
                subCatProductName: "Strawberries",
                subCatProductImage: STRAWBERRY_IMAGE,
            },
        ],
    },
    {
        categoryId: "VEG02",
        categoryName: "Vegetables",
        categoryImage: MIX_VEGETABLES_IMAGE,
        subCategory: [
            {
                subCatProductId: "07031010",
                subCatProductName: "Onion",
                subCatProductImage: ONION_IMAGE,
            },
            {
                subCatProductId: "0707",
                subCatProductName: "Cucumber",
                subCatProductImage: CUCUMBER_IMAGE,
            },
            {
                subCatProductId: "7099920",
                subCatProductName: "Drumstick",
                subCatProductImage: DRUMSTICK_IMAGE,
            },
            {
                subCatProductId: "12099120",
                subCatProductName: "Cauliflower",
                subCatProductImage: FLOWER_IMAGE,
            },
            {
                subCatProductId: "07101000",
                subCatProductName: "Potatoes",
                subCatProductImage: POTATOES_IMAGE,
            },
            {
                subCatProductId: "08055000",
                subCatProductName: "Lemons",
                subCatProductImage: LEMONS_IMAGE,
            },
            {
                subCatProductId: "07096010",
                subCatProductName: "Green Chilli",
                subCatProductImage: GREEN_CHILLI_IMAGE,
            },
            {
                subCatProductId: "07096010",
                subCatProductName: "Red Chilli",
                subCatProductImage: RED_CHILLI_IMAGE,
            },
            {
                subCatProductId: "07131020",
                subCatProductName: "Green Peas",
                subCatProductImage: GREEN_PEAS_IMAGE,
            },
            {
                subCatProductId: "07020000",
                subCatProductName: "Tomatoes",
                subCatProductImage: TOMATOES_IMAGE,
            },
            {
                subCatProductId: "07049010",
                subCatProductName: "Cabbage",
                subCatProductImage: CABBAGE_IMAGE,
            },
            {
                subCatProductId: "070320",
                subCatProductName: "Garlic",
                subCatProductImage: GARLIC_IMAGE,
            },
        ],
    },
    {
        categoryId: "SPI03",
        categoryName: "Spices",
        categoryImage: MIX_SPICES_IMAGE,
        subCategory: [
            {
                subCatProductId: "09042211",
                subCatProductName: "Chilli Powder",
                subCatProductImage: CHILLIPOWDER_IMAGE,
            },
            {
                subCatProductId: "09061110",
                subCatProductName: "Cinnamon",
                subCatProductImage: CINNAMON_IMAGE,
            },
            {
                subCatProductId: "09101210",
                subCatProductName: "Ginger Powder",
                subCatProductImage: SPICES_IMAGE,
            },
            {
                subCatProductId: "091030",
                subCatProductName: "Turmaric",
                subCatProductImage: TURMARIC_IMAGE,
            },
            {
                subCatProductId: "13019013",
                subCatProductName: "Asafetida",
                subCatProductImage: ASAFOETIDA_IMAGE,
            },
            {
                subCatProductId: "0909",
                subCatProductName: "Badiya",
                subCatProductImage: BADIYA_IMAGE,
            },
            {
                subCatProductId: "0908",
                subCatProductName: "Cardamom",
                subCatProductImage: CARADAMOM_IMAGE,
            },
            {
                subCatProductId: "0907",
                subCatProductName: "Clove",
                subCatProductImage: CLOVE_IMAGE,
            },
            {
                subCatProductId: "09092190",
                subCatProductName: "Coriander",
                subCatProductImage: CORIANDER_IMAGE,
            },
            {
                subCatProductId: "0909312",
                subCatProductName: "Cumin",
                subCatProductImage: CUMIN_IMAGE,
            },
            {
                subCatProductId: "0909",
                subCatProductName: "Fennel",
                subCatProductImage: FENNEL_IMAGE,
            },
            {
                subCatProductId: "17011310",
                subCatProductName: "Jaggery",
                subCatProductImage: JAGGERY_IMAGE,
            },
            {
                subCatProductId: "12119070",
                subCatProductName: "Mint",
                subCatProductImage: MINT_IMAGE,
            },
        ],
    },
    {
        categoryId: "DRYFRU04",
        categoryName: "Dry Fruits",
        categoryImage: MIX_DRY_FRUITS_IMAGE,
        subCategory: [
            {
                subCatProductId: "08021",
                subCatProductName: "Almonds",
                subCatProductImage: ALMONDS_IMAGE,
            },
            {
                subCatProductId: "08012200",
                subCatProductName: "Cashew",
                subCatProductImage: CASHEW_IMAGE,
            },
            {
                subCatProductId: "08135020",
                subCatProductName: "Mix Dry Fruits",
                subCatProductImage: MIXDRY_IMAGE,
            },
            {
                subCatProductId: "08062010",
                subCatProductName: "Raisins",
                productVarieties: [
                    { varietyName: "Golden Small Raisins", varietyHsCode: "08062010" },
                    { varietyName: "Golden Long Raisins", varietyHsCode: "08061000" },
                    { varietyName: "Black Raisins", varietyHsCode: "08062010" },
                ],
                subCatProductImage: RAISINS_IMAGE,
            },
            {
                subCatProductId: "08023200",
                subCatProductName: "Walnuts",
                subCatProductImage: WALNUTS_IMAGE,
            },
            {
                subCatProductId: "23050010",
                subCatProductName: "Ground Nuts",
                subCatProductImage: GROUND_NUTS_IMAGE,
            },
            {
                subCatProductId: "08025100",
                subCatProductName: "Pistachio",
                subCatProductImage: PISTACHIO_IMAGE,
            },
            {
                subCatProductId: "080420",
                subCatProductName: "Figs",
                subCatProductImage: FIGS_IMAGE,
            },
        ],
    },
    {
        categoryId: "GRS05",
        categoryName: "Grains",
        categoryImage: MIX_GRAINS_IMAGE,
        subCategory: [
            {
                subCatProductId: "10063090",
                subCatProductName: "Non Basmati Rice",
                subCatProductImage: NON_BASMATI_RICE_IMAGE,
            },
            {
                subCatProductId: "10063020",
                subCatProductName: "Basmati Rice",
                subCatProductImage: BASMATIRICE_IMAGE,
            },
            {
                subCatProductId: "11041200",
                subCatProductName: "Oats",
                subCatProductImage: CEREALS_IMAGE,
            },
            {
                subCatProductId: "10019910",
                subCatProductName: "Wheat",
                subCatProductImage: WHEAT_IMAGE,
            },
            {
                subCatProductId: "10071010",
                subCatProductName: "Sorghum",
                subCatProductImage: SORGHUM_IMAGE,
            },
            {
                subCatProductId: "100821",
                subCatProductName: "Millet",
                subCatProductImage: MILLET_IMAGE,
            },
            {
                subCatProductId: "10031000",
                subCatProductName: "Barley",
                subCatProductImage: SEED_IMAGE,
            },
            {
                subCatProductId: "12074090",
                subCatProductName: "Black Sesame",
                subCatProductImage: BLACK_SESAME_IMAGE,
            },
            {
                subCatProductId: "120740",
                subCatProductName: "White Sesame",
                subCatProductImage: WHITE_SESAME_IMAGE,
            },
        ],
    },
    {
        categoryId: "PLS06",
        categoryName: "Pulses",
        categoryImage: MIX_PULSES_IMAGE,
        subCategory: [
            {
                subCatProductId: "071320",
                subCatProductName: "Chickpea",
                subCatProductImage: CHICKPEA_IMAGE,
            },
            {
                subCatProductId: "07133300",
                subCatProductName: "Kidney Beans",
                subCatProductImage: KIDNEY_BEANS_IMAGE,
            },
            {
                subCatProductId: "07134000",
                subCatProductName: "Lentils",
                subCatProductImage: LENTILS_IMAGE,
            },
            {
                subCatProductId: "07133100",
                subCatProductName: "Mung Beans",
                subCatProductImage: MUNG_BEANS_IMAGE,
            },
            {
                subCatProductId: "07131020",
                subCatProductName: "Peas Green Split",
                subCatProductImage: PEAS_GREEN_SPLIT_IMAGE,
            },
            {
                subCatProductId: "07136000",
                subCatProductName: "Pigeon Peas",
                subCatProductImage: PIGEON_PEAS_IMAGE,
            },
            {
                subCatProductId: "12081000",
                subCatProductName: "Soya Beans",
                subCatProductImage: SOYA_BEANS_IMAGE,
            },
            {
                subCatProductId: "07133100",
                subCatProductName: "Urad",
                subCatProductImage: URAD_IMAGE,
            },
            {
                subCatProductId: "07139010",
                subCatProductName: "Yellow Split",
                subCatProductImage: YELLOW_SPLIT_IMAGE,
            },
        ],
    },
    {
        categoryId: "FRS07",
        categoryName: "Flours",
        categoryImage: MIX_FLOUR_IMAGE,
        subCategory: [
            {
                subCatProductId: "1105",
                subCatProductName: "Gram Flour",
                subCatProductImage: GRAM_FLOUR_IMAGE,
            },
            {
                subCatProductId: "11063090",
                subCatProductName: "Maida Flour",
                subCatProductImage: MAIDA_FLOUR_IMAGE,
            },
            {
                subCatProductId: "11029090",
                subCatProductName: "Millet Flour",
                subCatProductImage: MILLET_FLOUR_IMAGE,
            },
            {
                subCatProductId: "11029022",
                subCatProductName: "Rice Flour",
                subCatProductImage: RICE_FLOUR_IMAGE,
            },
            {
                subCatProductId: "19041090",
                subCatProductName: "Sorghum Flour",
                subCatProductImage: SORGHUM_FLOUR_IMAGE,
            },
            {
                subCatProductId: "11063090",
                subCatProductName: "Urad Flour",
                subCatProductImage: URAD_FLOUR_IMAGE,
            },
            {
                subCatProductId: "11010000",
                subCatProductName: "Wheat Flour",
                subCatProductImage: WHEAT_FLOUR_IMAGE,
            },
        ],
    },
    {
        categoryId: "RS08",
        categoryName: "Raw Material",
        categoryImage: COTTON_IMAGE,
        subCategory: [
            {
                subCatProductId: "1105",
                subCatProductName: "Cotton",
                subCatProductImage: COTTON_IMAGE,
            },
            {
                subCatProductId: "1105",
                subCatProductName: "Fox Nuts",
                subCatProductImage: FOX_NUTS_IMAGE,
            },
        ]
    },
    {
        categoryId: "MTS09",
        categoryName: "Metal Scrap",
        categoryImage: MIX_METAL_IMAGE,
        subCategory: [
            {
                subCatProductId: "76020010",
                subCatProductName: "Aluminum UBC Scrap",
                subCatProductImage: ALUMINUM_IMAGE,
            },
            {
                subCatProductId: "76012010",
                subCatProductName: "Aluminum Ignots Scrap",
                subCatProductImage: ALUMINUM_IGNOTS_IMAGE,
            },
            {
                subCatProductId: "76020010",
                subCatProductName: "Aluminum 6063 Scrap",
                subCatProductImage: ALUMINUM_6063_IMAGE,
            },
            {
                subCatProductId: "74040012",
                subCatProductName: "Aluminum wire Scrap",
                subCatProductImage: ALUMINUM_WIRE_IMAGE,
            },
            {
                subCatProductId: "7419",
                subCatProductName: "Copper",
                subCatProductImage: COPPER_IMAGE,
            },
            {
                subCatProductId: "7207",
                subCatProductName: "Iron",
                subCatProductImage: IRON_IMAGE,
            },
        ],
    },
    {
        categoryId: "USR10",
        categoryName: "Enter Your Own Product",
        categoryImage: OTHER_IMAGE,
    },
];
